// client/src/App.js
import React from 'react';
import './App.css'; // Import the CSS file
import Header from './header_files/Header';
import Footer from './footer_files/Footer';
import LandingPage from './LandingPage';
import TOSPage from "./TOS/TOSPage";
import PrivacyPage from './private_policy/PrivacyPage';
import MembershipPage from './memberships_page/membership';
import Contact from './contact/contact';
import About from './about/about';
import Dashboard from './dashboard/dashboard';
import ServerDash from './server_dash/serverDash';

import { Routes, Route } from 'react-router-dom'; // Import Routes and Route



function App() {
  return (
    <div className="app-container"> 
      <Header />
      <main className="main-content"> 
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/tos" element={<TOSPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/membership" element= {<MembershipPage/>}/>
          <Route path="/about" element={<About />} />
          <Route path="/dashboard" element={<Dashboard />}></Route>
          <Route path="/server_dash" element={<ServerDash />}></Route>
          <Route path="/settings"></Route>  
        </Routes>
      </main>
      <Footer />
    </div>
  );
}


export default App;